import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { OrganizationProvider } from "./context/OrganizationContext";
import ProtectedRoute, { RequireAuth } from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import SelectOrganizationPage from "./pages/SelectOrganizationPage";
import FilesPage from "./pages/FilesPage";
import InvoicePage from "./pages/InvoicePage";
import CompanyPage from "./pages/CompanyPage";
import BankDetailsPage from "./pages/BankDetailsPage";
import PersonalInfoPage from "./pages/PersonalInfoPage";
import OrganizationManagementPage from "./pages/OrganizationManagementPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AcceptInvitationPage from "./pages/AcceptInvitationPage";
import DocsPage from "./pages/DocsPage";
import AssetsPage from "./pages/AssetsPage";
import AssetAssignmentsPage from "./pages/AssetAssignmentsPage";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <OrganizationProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/accept-invite" element={<AcceptInvitationPage />} />
            <Route element={<RequireAuth />}>
              <Route path="/select-organization" element={<SelectOrganizationPage />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              <Route element={<DashboardLayout />}>
                <Route path="/documents" element={<FilesPage />} />
                <Route path="/invoices" element={<InvoicePage />} />
                <Route path="/companies" element={<CompanyPage />} />
                <Route path="/bank-details" element={<BankDetailsPage />} />
                <Route path="/sender-profiles" element={<PersonalInfoPage />} />
                <Route path="/team" element={<OrganizationManagementPage />} />
                <Route path="/assets" element={<AssetsPage />} />
                <Route path="/assets/assignment" element={<AssetAssignmentsPage />} />
              </Route>
              <Route path="/dashboard" element={<Navigate to="/documents" replace />} />
              <Route path="/dashboard/invoice" element={<Navigate to="/invoices" replace />} />
              <Route path="/dashboard/company" element={<Navigate to="/companies" replace />} />
              <Route path="/dashboard/bank" element={<Navigate to="/bank-details" replace />} />
              <Route path="/dashboard/personal" element={<Navigate to="/sender-profiles" replace />} />
              <Route path="/dashboard/organization" element={<Navigate to="/team" replace />} />
              <Route path="/dashboard/assets" element={<Navigate to="/assets" replace />} />
              <Route path="/dashboard/assets/assignments" element={<Navigate to="/assets/assignment" replace />} />
            </Route>
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3500}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            theme="light"
            toastClassName="invoice-toast"
          />
        </OrganizationProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
